export const TEXT_FIELD_VALUE_MIN_LENGTH = 2;
export const TEXT_FIELD_VALUE_MAX_LENGTH = 400;
export const TEXT_AREA_MAX_LENGTH = 2000;
